module.exports = __webpack_public_path__ + "img/Color Fill 1.d7b01ab1.png";